export const STORAGE_MAX_PACK_QTY = 1000000;
export const STORAGE_PACK_NAME_MAX_LENGTH = 50;
